import { Box, Typography } from '@mui/material';

import { FuncionarioMin } from '../../../models/Transferencia.model';
import Currency from '../../components/Currency';

interface Props {
  funcionarios: FuncionarioMin[];
  tipo: 'envio' | 'estorno';
  valorTotal: number;
}

const ResumoTransferencia = ({ funcionarios, tipo, valorTotal }: Props) => {
  const valorIndividual =
    funcionarios.length > 0 &&
    funcionarios.every((usuario) => usuario.valor === funcionarios[0].valor)
      ? funcionarios[0].valor
      : null;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={2}
      width={1}
      p={1.5}
      borderRadius={1.5}
      sx={{ background: 'linear-gradient(110deg, #EDF4FF 0%, #FFFFFF 100%)' }}
    >
      <Box>
        <Typography color="#17234D" fontSize={12} fontWeight={600}>
          Total a ser {tipo === 'envio' ? 'distribuído' : 'estornado'}
        </Typography>
        <Typography color={tipo === 'envio' ? '#0879E5' : '#D92336'} fontSize={22} fontWeight={700}>
          <Currency value={valorTotal} />
        </Typography>
      </Box>
      <Box textAlign="right">
        <Typography color="#68778F" fontSize={12}>
          {funcionarios.length} {funcionarios.length === 1 ? 'usuário' : 'usuários'}
        </Typography>
        <Typography color="#68778F" fontSize={12}>
          {valorIndividual === null ? (
            'Valores individuais'
          ) : (
            <>
              <Currency value={valorIndividual} /> cada
            </>
          )}
        </Typography>
      </Box>
    </Box>
  );
};

export default ResumoTransferencia;
